var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 8000,
    zoomAndPan: "magnify",
    viewBox: "0 0 6000 1049.999947",
    height: 1400,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.891265, 808.874701)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 608 -80 L 608 -560 L 480 -560 L 480 -128 L 192 -128 L 192 -560 L 4 -560 L 4 -432 L 64 -432 L 64 -80 L 144 0 L 528 0 Z M 608 -80 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1017.492365, 808.874701)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 568 0 L 568 -560 L 440 -560 L 440 -216 L 192 -560 L 4 -560 L 4 -432 L 64 -432 L 64 0 L 192 0 L 192 -343.199219 L 440 0 Z M 568 0 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1711.093531, 808.874701)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2116.694266, 808.874701)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 520 0 L 600 -80 L 600 -200 L 520 -280 L 600 -360 L 600 -480 L 520 -560 L 4 -560 L 4 -432 L 64 -432 L 64 0 Z M 472 -128 L 192 -128 L 192 -216 L 472 -216 Z M 472 -344 L 192 -344 L 192 -432 L 472 -432 Z M 472 -344 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2842.295581, 808.874701)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 552 0 L 552 -128 L 192 -128 L 192 -560 L 4 -560 L 4 -432 L 64 -432 L 64 0 Z M 552 0 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3487.896841, 808.874701)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 544 0 L 624 -80 L 624 -480 L 544 -560 L 120 -560 L 40 -480 L 40 -80 L 120 0 Z M 496 -128 L 168 -128 L 168 -432 L 496 -432 Z M 496 -128 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4237.497967, 808.874701)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 524 0 L 604 -80 L 604 -344 L 340 -344 L 340 -216 L 476 -216 L 476 -128 L 168 -128 L 168 -432 L 544 -432 L 544 -560 L 120 -560 L 40 -480 L 40 -80 L 120 0 Z M 524 0 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4967.09922, 808.874701)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 492 0 L 572 -80 L 572 -264 L 492 -344 L 168 -344 L 168 -432 L 572 -432 L 572 -560 L 120 -560 L 40 -480 L 40 -296 L 120 -216 L 444 -216 L 444 -128 L 40 -128 L 40 0 Z M 492 0 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(363.295194, 799.12511)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 608 -80 L 608 -560 L 480 -560 L 480 -128 L 192 -128 L 192 -560 L 4 -560 L 4 -432 L 64 -432 L 64 -80 L 144 0 L 528 0 Z M 608 -80 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1096.896293, 799.12511)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 568 0 L 568 -560 L 440 -560 L 440 -216 L 192 -560 L 4 -560 L 4 -432 L 64 -432 L 64 0 L 192 0 L 192 -343.199219 L 440 0 Z M 568 0 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1790.497459, 799.12511)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2196.098194, 799.12511)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 520 0 L 600 -80 L 600 -200 L 520 -280 L 600 -360 L 600 -480 L 520 -560 L 4 -560 L 4 -432 L 64 -432 L 64 0 Z M 472 -128 L 192 -128 L 192 -216 L 472 -216 Z M 472 -344 L 192 -344 L 192 -432 L 472 -432 Z M 472 -344 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2921.69951, 799.12511)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 552 0 L 552 -128 L 192 -128 L 192 -560 L 4 -560 L 4 -432 L 64 -432 L 64 0 Z M 552 0 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3567.30077, 799.12511)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 544 0 L 624 -80 L 624 -480 L 544 -560 L 120 -560 L 40 -480 L 40 -80 L 120 0 Z M 496 -128 L 168 -128 L 168 -432 L 496 -432 Z M 496 -128 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4316.901896, 799.12511)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 524 0 L 604 -80 L 604 -344 L 340 -344 L 340 -216 L 476 -216 L 476 -128 L 168 -128 L 168 -432 L 544 -432 L 544 -560 L 120 -560 L 40 -480 L 40 -80 L 120 0 Z M 524 0 "
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5046.503148, 799.12511)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 492 0 L 572 -80 L 572 -264 L 492 -344 L 168 -344 L 168 -432 L 572 -432 L 572 -560 L 120 -560 L 40 -480 L 40 -296 L 120 -216 L 444 -216 L 444 -128 L 40 -128 L 40 0 Z M 492 0 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(323.593228, 803.999906)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 608 -80 L 608 -560 L 480 -560 L 480 -128 L 192 -128 L 192 -560 L 4 -560 L 4 -432 L 64 -432 L 64 -80 L 144 0 L 528 0 Z M 608 -80 "
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1057.194328, 803.999906)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 568 0 L 568 -560 L 440 -560 L 440 -216 L 192 -560 L 4 -560 L 4 -432 L 64 -432 L 64 0 L 192 0 L 192 -343.199219 L 440 0 Z M 568 0 "
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2156.396229, 803.999906)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 520 0 L 600 -80 L 600 -200 L 520 -280 L 600 -360 L 600 -480 L 520 -560 L 4 -560 L 4 -432 L 64 -432 L 64 0 Z M 472 -128 L 192 -128 L 192 -216 L 472 -216 Z M 472 -344 L 192 -344 L 192 -432 L 472 -432 Z M 472 -344 "
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2881.997545, 803.999906)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 552 0 L 552 -128 L 192 -128 L 192 -560 L 4 -560 L 4 -432 L 64 -432 L 64 0 Z M 552 0 "
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3527.598805, 803.999906)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 544 0 L 624 -80 L 624 -480 L 544 -560 L 120 -560 L 40 -480 L 40 -80 L 120 0 Z M 496 -128 L 168 -128 L 168 -432 L 496 -432 Z M 496 -128 "
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4277.199931, 803.999906)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 524 0 L 604 -80 L 604 -344 L 340 -344 L 340 -216 L 476 -216 L 476 -128 L 168 -128 L 168 -432 L 544 -432 L 544 -560 L 120 -560 L 40 -480 L 40 -80 L 120 0 Z M 524 0 "
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5006.801183, 803.999906)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 492 0 L 572 -80 L 572 -264 L 492 -344 L 168 -344 L 168 -432 L 572 -432 L 572 -560 L 120 -560 L 40 -480 L 40 -296 L 120 -216 L 444 -216 L 444 -128 L 40 -128 L 40 0 Z M 492 0 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.10472e1e5daf44cd5863ab9a5e010822.svg";
export { ForwardRef as ReactComponent };